<template>
  <div class="navbar">
    <ul class="navitems">
      <li
        @click="pushRouteTo('/plans/select')"
        :class="{ active: $route.path.indexOf('plans') > 0 }"
      >
        <i class="far fa-calendar-alt"></i>
        Audit a QHA
      </li>
      <li
        v-if="canViewItem('admin')"
        @click="$router.push('/reports/dashboard')"
        :class="{ active: isReportsRoute }"
      >
        <i class="far fa-clipboard"></i>
        Reports
      </li>
      <li
        v-if="canViewItem('admin')"
        @click="$router.push('/admin/users')"
        :class="{ active: $route.path.indexOf('admin') > 0 }"
      >
        <i class="fas fa-database"></i>
        Coordinator
      </li>
      <li
        @click="$router.push('/support')"
        :class="{ active: $route.path.indexOf('support') > 0 }"
      >
        <i class="far fa-life-ring"></i>
        Support
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

const allRoutes = [
  { path: '/plans/select', name: 'select' },
  { path: '/reports/dashboard', name: 'reports' },
  { path: '/admin/users', name: 'coordinator' },
  { path: '/support', name: 'support' }
]

export default {
  name: 'TopNav',
  computed: {
    ...mapGetters({
      role: 'user/role'
    }),
    isReportsRoute() {
      return this.$route.path.indexOf('reports') > 0 ||
        this.$route.path === '/sectiondata' ||
        this.$route.path === '/gradings'
    }
  },
  methods: {
    ...mapActions({
      resetAudit: 'audit/reset'
    }),
    active(page) {
      return (this.$route.path.indexOf(page) > 0)
    },
    pushRouteTo(route) {
      try {
        const routeRequest = allRoutes.find(r => r.path === route)
        const isRouteActive = this.active(routeRequest.name)

        this.resetAudit()

        if (!isRouteActive) {
          this.$router.push(route)
        }
      } catch (error) {
        console.log(error)
      }
    },
    canViewItem(resource) {
      switch (resource) {
        case 'admin':
          return !!['manage', 'admin', 'super'].includes(this.role)
        case 'reports':
          return !!['report', 'manage', 'admin', 'super'].includes(this.role)
        case 'super':
          return !!['super'].includes(this.role)
        default:
          return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/nav.scss';

li {
  color: lightgrey;
}
</style>
